import type {ShowLocalNotifFn} from '../shared/WebNativeBridge.types'

export const showLocalNotification: ShowLocalNotifFn = async ({title, message}, notifData, tag) => {
  // TODO
}
